import { DepositAccountsV2Context } from 'contexts/depositAccountsV2Context'
import { useContext } from 'react'

export const useDepositAccountsV2Context = () => useContext(DepositAccountsV2Context)
